import React, { useRef, useState } from 'react';
import { FaPlay, FaPause } from 'react-icons/fa';

const CategoryVideo = () => {
  const videoLink = 'https://cdn.pixabay.com/video/2024/04/25/209424_large.mp4';
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="w-full h-[520px] rounded-[40px] overflow-hidden relative">
      {/* Video Element */}
      <video
        ref={videoRef}
        className="w-full h-full object-cover"
        src={videoLink}
        loop
      />
      {/* Overlay with Play Button */}
      {!isPlaying && (
        <div
          className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handlePlayClick}
        >
          <div className="w-16 h-16 rounded-full bg-[#c1c3c3] flex items-center justify-center cursor-pointer hover:bg-[#b1b3b3] transition-colors">
            <FaPlay className="text-white ml-1" size={20} />
          </div>
        </div>
      )}
      {isPlaying && (
        <div
          className="absolute bottom-4 left-4 p-2 bg-black bg-opacity-50 rounded-full cursor-pointer hover:bg-opacity-70 transition-opacity"
          onClick={handlePlayClick}
        >
          <FaPause className="text-white" size={20} />
        </div>
      )}
    </div>
  );
};

export default CategoryVideo;
